export default "__VITE_ASSET__CN4$tgh4__"